import Smartview from 'widgets/smartviews/Smartview'
import {
  ExecuteOperationOnPipe,
  ModelWithForm,
  ResetFormOnPipe,
  TriggerPipelineOnFormSubmit,
  useValue
} from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import { Translation, Translator } from '@morningtrain/react-translations'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { SubmitButton } from 'ui/buttons'
import { Pipeline } from '@morningtrain/react-helpers'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import React from 'react'
import ButtonWrap from 'ui/layouts/ButtonWrap'
import { Fieldset } from 'layouts/index'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'
import * as UI from 'ui'

export function TagSmartview () {
  const modelKey = useValue('id')

  const isCreate = modelKey == null

  return (
    <Translator namespace='files.tags'>
      <Smartview header={<Translation name={isCreate ? 'create_title' : 'edit_title'} />}>
        <ModelWithForm resourceName='files.tags' operationName='read' id={modelKey}>
          <Fieldset cols={1}>
            <Fields.File name='thumbnail' label='Thumbnail' />
            <Fields.Input name='name_da' label={<Translation name='name_da' />} />
            <Fields.Input name='name_en' label={<Translation name='name_en' />} />
          </Fieldset>
          <SmartviewContentSeparator />
          <ButtonWrap>
            <DeleteModelOnClick
              pipes={(
                <>
                  <ExecuteOperationOnPipe operationName='index' />
                  <ResetSmartviewOnPipe />
                </>
              )}
            >
              <UI.SquareButton color='red' big>
                <UI.Icons.Trash className='w-4 h-4' />
              </UI.SquareButton>
            </DeleteModelOnClick>
            <SubmitButton>
              <Translation name='generic.save' />
            </SubmitButton>

            <Pipeline>
              <TriggerPipelineOnFormSubmit />
              <ExecuteOperationOnPipe operationName='index' />
              {isCreate ? <ResetFormOnPipe /> : null}
            </Pipeline>
          </ButtonWrap>
        </ModelWithForm>
      </Smartview>
    </Translator>
  )
}
